import { withColor } from '../../../ColorContext'
import CheckWithLinkControl from './component/CheckWithLink'

export default withColor(CheckWithLinkControl)
